import React from 'react';

export function SettingsStatusChip({
  tone,
  children,
}: {
  tone: 'ok' | 'warn' | 'muted' | 'err';
  children: React.ReactNode;
}) {
  const cls =
    tone === 'ok'
      ? 'bg-emerald-50 text-emerald-800'
      : tone === 'warn'
        ? 'bg-amber-50 text-amber-900'
        : tone === 'err'
          ? 'bg-red-50 text-red-700'
          : 'bg-app-surface-muted text-app-text-muted';
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium ${cls}`}>{children}</span>
  );
}
